import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Panel from "../components/Panel";
import KpiCard from "../components/KpiCard";
import { fmtINR, fmtDate } from "../lib/format";

const STAGE_ORDER = ["Prospecting", "Under Review", "Preparing Bid", "Submitted"];
const STAGE_COLOR = { "Prospecting": "#8892B0", "Under Review": "#fb8b1e", "Preparing Bid": "#0068ff", "Submitted": "#4af6c3" };

export default function Tenders() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/tenders").then((r) => setData(r.data)); }, []);
    if (!data) return <div className="font-mono-fin text-sm text-[var(--text-secondary)]">// LOADING TENDERS...</div>;

    const byStage = {};
    STAGE_ORDER.forEach((s) => { byStage[s] = []; });
    data.tenders.forEach((t) => { if (byStage[t.stage]) byStage[t.stage].push(t); });

    return (
        <div className="space-y-4">
            <div>
                <div className="font-mono-fin text-[10px] uppercase tracking-[0.25em] text-[var(--brand-amber)] mb-1">// BUSINESS DEVELOPMENT</div>
                <h1 className="font-display font-black text-3xl">Tender Pipeline</h1>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <KpiCard testId="tnd-pipeline" label="Pipeline Value" value={data.summary.total_pipeline} sub={`${data.tenders.length} tenders`} accent />
                <KpiCard testId="tnd-expected" label="Probability-Weighted" value={data.summary.expected_win} sub="Expected wins" />
                <KpiCard testId="tnd-submitted" label="Submitted" value={data.summary.submitted} format="custom" sub="Awaiting result" />
                <KpiCard testId="tnd-margin" label="Avg Margin" value={`${data.summary.avg_margin.toFixed(1)}%`} format="custom" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
                {STAGE_ORDER.map((stage) => (
                    <div key={stage} className="bg-panel border border-panel" data-testid={`stage-${stage.toLowerCase().replace(/ /g, "-")}`}>
                        <div className="px-3 py-2 border-b border-panel flex items-center justify-between">
                            <span className="text-[11px] font-mono-fin uppercase tracking-[0.15em]" style={{ color: STAGE_COLOR[stage] }}>{stage}</span>
                            <span className="text-[10px] font-mono-fin text-[var(--text-secondary)]">{byStage[stage].length}</span>
                        </div>
                        <div className="p-2 space-y-2 min-h-[100px]">
                            {byStage[stage].map((t) => (
                                <div key={t.id} className="border border-panel p-2.5 hover:border-[var(--brand-amber)] transition-colors">
                                    <div className="text-[11px] font-body text-[var(--text-primary)] leading-tight">{t.name}</div>
                                    <div className="text-[9px] font-mono-fin uppercase tracking-wider text-[var(--text-secondary)] mt-1">{t.authority}</div>
                                    <div className="flex items-center justify-between mt-2">
                                        <span className="font-mono-fin text-xs text-amber">{fmtINR(t.value)}</span>
                                        <div className="flex items-center gap-1.5">
                                            <div className="w-10 h-1 bg-[var(--bg-base)] border border-panel">
                                                <div className="h-full" style={{ width: `${t.win_prob}%`, background: t.win_prob >= 50 ? "#4af6c3" : t.win_prob >= 30 ? "#fb8b1e" : "#ff433d" }} />
                                            </div>
                                            <span className="text-[10px] font-mono-fin" style={{ color: t.win_prob >= 50 ? "#4af6c3" : t.win_prob >= 30 ? "#fb8b1e" : "#ff433d" }}>{t.win_prob}%</span>
                                        </div>
                                    </div>
                                    <div className="mt-2 flex items-center justify-between text-[9px] font-mono-fin uppercase tracking-wider">
                                        <span className="text-[var(--text-secondary)]">Open {fmtDate(t.opening)}</span>
                                        <span className="text-pos">{t.expected_margin.toFixed(1)}%</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
